(function () {
    "use strict";

    angular
        .module("Finance")
        .factory("$fileService", [
            "$http", "$oidc", "Blob", "FileSaver", "$activity", "$notification",
            function ($http, oidc, Blob, FileSaver, $activity, $notification) {
                var $fileService = {};

                // Save response to file
                $fileService.saveResponseToFile = function(response){
                    var contentDisposition = response.headers("content-disposition");
                    var regex = /filename="*([^"].+[^"])"*;/g;
                    var result = regex.exec(contentDisposition);
                    var fileName = result[1];
                    var data = new Blob([response.data], { type: response.headers("content-type") });
                    FileSaver.saveAs(data, fileName);
                }

                // Download file
                $fileService.downloadFile = function (fileId) {
                    $activity.start();
                    $http
                        .get("/api/file/" + fileId, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            },
                            responseType: 'arraybuffer',
                        })
                        .then(
                            function (response) {
                                $fileService.saveResponseToFile(response);
                            },
                            function (response) {
                                $notification.addError(response.statusText);
                            }
                        )
                        .then(function () {
                            $activity.finish();
                        });
                };

                return $fileService;
            }
        ]);
})();